<template>
  <div class="locker-selection">
    <div />
    <div class="smart-locker">
      <template v-if="smartLockerCounterData.length === 0">
        <div>{{ $t('SmartLocker.NoLockerData') }}</div>
      </template>
      <template v-else>
        <div class="smart-locker-title">
          <span class="smart-locker-title-important">{{ $t('SmartLocker.SmartLockerPosition') }}： {{ currentOwnerGroupName }}</span>
        </div>
        <div class="smart-locker-selector">
          <div
            class="pre-smart-locker smart-locker-control-btn"
            :class="{ 'can-click': nowSmartLockerIndex > 1 }"
            @click="nowSmartLockerIndex > 1 ? controlSmartLocker(-1) : ''"
          >
            <i class="icon-m-back" />
          </div>
          <div class="smart-locker-content" :style="{ width: smartLockerContentWidth }">
            <template v-if="showSmartLockerCounterData.length > 0">
              <div v-for="(row, index) in showSmartLockerCounterData" :key="`row_${index}`" class="row">
                <div
                  v-for="(col, index2) in row"
                  :key="`row_${index}_col_${index2}`"
                  class="col"
                  :style="{ height: col.heightPercent }"
                >
                  <div
                    v-for="counter in col.CounterShapeDescriptionList"
                    :key="counter.CounterId"
                    class="counter"
                    :class="{
                      'disabled-block': !counter.Enable && !counter.IsComputer,
                      'used-block': counter.Used || counter.IsComputer,
                      'not-use-block': !counter.Used && !counter.IsComputer
                    }"
                    :style="{ width: counter.widthPercent }"
                  >
                    <div v-if="counter.IsComputer" class="computer">
                      <div class="screen"></div>
                      <div class="control">
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <span v-else>
                      {{ counter.CounterName }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            class="next-smart-locker smart-locker-control-btn"
            :class="{ 'can-click': nowSmartLockerIndex < smartLockerCounterData.length }"
            @click="nowSmartLockerIndex < smartLockerCounterData.length ? controlSmartLocker(1) : ''"
          >
            <i class="icon-m-next" />
          </div>
        </div>
        <div class="smart-locker-title-total">{{ nowSmartLockerIndex }} / {{ smartLockerCounterData.length }}</div>
      </template>
    </div>
    <div>
      <div class="status-interpretation">
        <div class="block used-block" />
        <div>{{ $t('SmartLocker.Use') }}</div>
      </div>
      <div class="status-interpretation">
        <div class="block not-use-block" />
        <div>{{ $t('SmartLocker.NotUse') }}</div>
      </div>
      <div class="status-interpretation">
        <div class="block disabled-block" />
        <div>{{ $t('SmartLocker.Disabled') }}</div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    smartLockerCounterData: Array,
    nowSmartLockerIndex: Number,
    selectedGroupId: String
  },
  computed: {
    showSmartLockerCounterData () {
      if (this.smartLockerCounterData.length >= this.nowSmartLockerIndex && this.nowSmartLockerIndex > 0) {
        return this.smartLockerCounterData[this.nowSmartLockerIndex - 1]?.CounterShapeDescriptionListGroupList || []
      }
      return []
    },
    showSmartLockerStoreData () {
      if (this.smartLockerStoreData.length >= this.nowSmartLockerIndex) {
        return this.smartLockerStoreData[this.nowSmartLockerIndex - 1]
      }
      return []
    },
    smartLockerContentWidth () {
      const width = 151 * this.showSmartLockerCounterData.length
      return `${width}px`
    },
    currentOwnerGroupName () {
      if (!this.smartLockerCounterData?.length) return ''
      const current = this.smartLockerCounterData[this.nowSmartLockerIndex - 1]
      return current?.OwnerGroupName || ''
    }
  },
  methods: {
    controlSmartLocker (index) {
      this.$emit('controlSmartLocker', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.locker-selection {
  display: flex;
  align-items: center;
  margin-top: 28px;
  padding-block: 28px 40px;
  border: 1px solid $borderDark1;
  border-radius: 8px;
  & > div:nth-child(1),
  & > div:nth-child(3) {
    width: 15%;
  }
  .smart-locker {
    width: 70%;
    .smart-locker-title {
      .smart-locker-title-important {
        color: $mainFontColor;
        font-size: map-get($fontSize, xx-large);
        font-weight: bold
      }
    }
    .smart-locker-selector {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px;
      height: 287px;
      margin-top: 25px;
      .smart-locker-control-btn {
        cursor: pointer;
        font-size: 40px;
        color: $lightFontColor;
        padding: 10px;
        &.can-click {
          color: $grayFontColor;
        }
      }
      .smart-locker-content {
        display: flex;
        gap: 4px;
        min-height: 100%;
        background-color: $bgDark3;
        border-radius: 8px;
        padding: 12px;
        .row {
          width: 100%;
          .col {
            display: flex;
            gap: 4px;
            margin-bottom: 4px;
            .counter {
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              .computer {
                height: 80%;
                width: 55%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .screen {
                  height: 80%;
                  border-radius: 4px;
                  background-color: $skyBlue;
                }
                .control {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  height: 20%;
                  max-height: 10px;
                  & > div {
                    width: 22px;
                    height: 100%;
                    border-radius: 2px;
                  }
                  & > div:nth-child(1) {
                    background-color: $bgDark3;
                  }
                  & > div:nth-child(2) {
                    background-color: $borderDark4;
                  }
                }
              }
            }
          }
        }
      }
    }
    .smart-locker-title-total {
      font-size: map-get($fontSize, small);
      color: $subFontColor;
      margin-top: 20px;
    }
  }
  .status-interpretation {
    display: flex;
    align-items: center;
    justify-content: left;
    margin-top: 12px;
    font-size: map-get($fontSize, small);
    .block {
      width: 15px;
      height: 15px;
      margin-right: 9px;
    }
  }
}
</style>
